import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = {
  key: 0,
  class: "block"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex flex-column align-items-center my-3 gap-3" }
const _hoisted_5 = { class: "flex justify-content-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_FieldErrors = _resolveComponent("FieldErrors")!
  const _component_Cropper = _resolveComponent("Cropper")!
  const _component_PrimeVueDialog = _resolveComponent("PrimeVueDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_PrimeVueButton, {
        label: "Select image",
        disabled: _ctx.disabled,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialog = true))
      }, null, 8, ["disabled"]),
      (_ctx.modelValue || _ctx.imageUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "block mt-3 max-w-full",
            src: _ctx.modelValue || _ctx.imageUrl,
            style: _normalizeStyle({ 'max-width': _ctx.previewMaxWidth ? `${_ctx.previewMaxWidth}px` : undefined })
          }, null, 12, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.name)
        ? (_openBlock(), _createBlock(_component_FieldErrors, {
            key: 2,
            class: "mt-3",
            "errors-map": _ctx.errorsMap,
            name: _ctx.name
          }, null, 8, ["errors-map", "name"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_PrimeVueDialog, {
      visible: _ctx.dialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialog) = $event)),
      header: "Image",
      style: { width: '40vw' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("input", {
          class: "block mb-3",
          type: "file",
          accept: "image/*",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
        }, null, 32),
        (_ctx.imageBase64)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_Cropper, {
                class: "cropper",
                ref: "cropper",
                src: _ctx.imageBase64,
                "stencil-props": _ctx.stencilProps,
                "stencil-size": _ctx.stencilSize,
                "default-size": _ctx.defaultSize,
                "image-restriction": "stencil",
                style: { height: '50vh' },
                onChange: _ctx.onCropperChange,
                onReady: _ctx.onCropperReady
              }, null, 8, ["src", "stencil-props", "stencil-size", "default-size", "onChange", "onReady"]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_PrimeVueButton, {
                    class: "p-button-rounded p-button-text p-button-secondary",
                    icon: "pi pi-search-minus",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onZoom(0.75)))
                  }),
                  _createVNode(_component_PrimeVueButton, {
                    class: "p-button-rounded p-button-text p-button-secondary",
                    icon: "pi pi-search-plus",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onZoom(1.35)))
                  })
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-sm text-gray-300" }, "Also you can zoom with mouse wheel or touchpad ☝️", -1))
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_PrimeVueButton, {
          label: _ctx.$t('save'),
          icon: "pi pi-save",
          onClick: _ctx.save
        }, null, 8, ["label", "onClick"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}